const usersStore = {
  users: [
    {
      id: '',
      email: '',
      first_name: '',
      last_name: '',
      avatar: '',
    },
  ],
}

export default usersStore
